import {
  type OrderDraftItemMutationStatusEnum,
  OrderDraftItemMutationStatuses,
} from '../../../hooks/useOrderDraftItemMutationStatusContext/OrderDraftItemMutationStatusEnum'

const FAILURE_STATUSES = new Set<OrderDraftItemMutationStatusEnum>([
  OrderDraftItemMutationStatuses.FAILED_TO_CREATE,
  OrderDraftItemMutationStatuses.FAILED_TO_UPDATE,
])

export class CheckIsFailureMutationStatusUseCase {
  execute = (status: OrderDraftItemMutationStatusEnum): boolean => {
    return FAILURE_STATUSES.has(status)
  }
}
